var formValidation = require("base/components/formValidation");
var createErrorNotification = require("base/components/errorNotification");

module.exports = {
    login: function () {
        $("form.login").submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr("action");
            form.spinner().start();
            $("form.login").trigger("login:submit", e);
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                        $("form.login").trigger("login:error", data);
                    } else {
                        $("form.login").trigger("login:success", data);
                        window.location.href = data.redirectUrl;
                    }

                    if (data.resetPassword === true) {
                        $(".js-reset-password-magento").removeClass("d-none");
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $("form.login").trigger("login:error", data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });
    },

    register: function () {
        $("form.registration").submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr("action");
            form.spinner().start();
            $("form.registration").trigger("login:register", e);
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        $("form.registration").trigger("login:register:error", data);
                        formValidation(form, data);
                    } else {
                        $("form.registration").trigger("login:register:success", data);
                        window.location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification($(".error-messaging"), err.responseJSON.errorMessage);
                    }

                    form.spinner().stop();
                }
            });
            return false;
        });
    },

    resetPassword: function () {
        $(".reset-password-form").submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr("action");
            form.spinner().start();
            $(".reset-password-form").trigger("login:register", e);
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $(".request-password-title").text(data.receivedMsgHeading);
                        $(".request-password-body").empty()
                            .append("<p>" + data.receivedMsgBody + "</p>");
                        if (!data.mobile) {
                            $("#submitEmailButton").text(data.buttonText)
                                .attr("data-dismiss", "modal");
                        } else {
                            $(".send-email-btn").empty()
                                .html("<a href=\""
                                    + data.returnUrl
                                    + "\" class=\"btn btn-primary btn-block\">"
                                    + data.buttonText + "</a>");
                        }

                        // Trigger gtm event
                        var queryString = window.location.search;
                        var urlParams = new URLSearchParams(queryString);
                        var urlFrom = urlParams.get("from");
                        var tunnel = "false";
                        if (urlFrom === "cart") {
                            tunnel = "true";
                        }
                        window.gtm.addEventToBuffer(window.gtm.events.RESET_PASSWORD, {tunnel: tunnel}, true);
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    },

    clearResetForm: function () {
        $("#login .modal").on("hidden.bs.modal", function () {
            $("#reset-password-email").val("");
            $(".modal-dialog .form-control.is-invalid").removeClass("is-invalid");
        });
    }
};

// Function to show password
const showPassword = (target) => {
    const elmt = $(target);

    $(elmt).on("click", (e) => {
        const $target = $(e.target);
        if ($target.hasClass("js-see-password")) {
            const inputPassword = $(e.currentTarget).find(".js-password");

            if (inputPassword[0].type === "password") {
                inputPassword[0].type = "text";
            } else {
                inputPassword[0].type = "password";
            }
        }
    });
};
showPassword(".show-password");

// Function to toggle the disabled attribut
const createAccountDisabledToggle = (target) => {
    const elmt = $(target);

    $(elmt).on("click", () => {
        let $submit = $(".js-create-account-submit");
        if ($submit.attr("disabled")) {
            $submit.removeAttr("disabled");
        } else {
            $submit.attr("disabled", "disabled");
        }
    });
};
createAccountDisabledToggle(".js-create-account");
